import script from "./AccountConfirmationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountConfirmationModal.vue?vue&type=script&setup=true&lang=js"

import "./AccountConfirmationModal.vue?vue&type=style&index=0&id=70a2c7ca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70a2c7ca"]])

export default __exports__